import { render, staticRenderFns } from "./PublicOrganizationParticipationCard.vue?vue&type=template&id=46559c6a&scoped=true"
import script from "./PublicOrganizationParticipationCard.vue?vue&type=script&lang=js"
export * from "./PublicOrganizationParticipationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46559c6a",
  null
  
)

export default component.exports